import {InfoIcon} from '@primer/octicons-react'
import {Link} from '@primer/react'
import type {BetterSystemStyleObject} from '@primer/styled-react'
import {Box} from '@primer/styled-react'
import {Octicon} from '@primer/react/deprecated'

import {Fragment} from 'react'
import {isEnterprise} from '@github-ui/runtime-environment'
import {clsx} from 'clsx'
import styles from './ContributorFooter.module.css'

export type ContributorFooterProps = {
  contributingFileUrl?: string
  securityPolicyUrl?: string
  codeOfConductFileUrl?: string
  supportFileUrl?: string
  sx?: BetterSystemStyleObject
  className?: string
}

export function ContributorFooter({
  contributingFileUrl,
  securityPolicyUrl,
  codeOfConductFileUrl,
  supportFileUrl,
  sx,
  className,
}: ContributorFooterProps) {
  if (isEnterprise() || (!contributingFileUrl && !securityPolicyUrl && !codeOfConductFileUrl && !supportFileUrl))
    return null

  const Links = () => {
    const existingLinks = []

    if (contributingFileUrl) {
      existingLinks.push(
        <Link underline href={contributingFileUrl}>
          contributing guidelines
        </Link>,
      )
    }

    if (securityPolicyUrl) {
      existingLinks.push(
        <Link underline href={securityPolicyUrl}>
          security policy
        </Link>,
      )
    }

    if (codeOfConductFileUrl) {
      existingLinks.push(
        <Link underline href={codeOfConductFileUrl}>
          code of conduct
        </Link>,
      )
    }
    if (supportFileUrl) {
      existingLinks.push(
        <Link underline href={supportFileUrl}>
          Support
        </Link>,
      )
    }

    if (existingLinks.length === 1) return <>{existingLinks.pop()}</>

    const lastLink = existingLinks.pop()
    return (
      <>
        {existingLinks.map((link, i) => (
          // eslint-disable-next-line @eslint-react/no-array-index-key
          <Fragment key={i}>
            {link}
            <span>{i !== existingLinks.length - 1 ? ', ' : ' '}</span>
          </Fragment>
        ))}
        <span>and {lastLink}</span>
      </>
    )
  }

  return (
    <Box data-testid="contributor-footer" sx={sx} className={clsx(styles.ContributorFooterContainer, className)}>
      <Octicon icon={InfoIcon} className={styles.infoIconWrapper} />
      <div data-testid="contributor-footer-text">
        {/*
          🚨 Heads up! These spans are like a house of cards - touch them and
          built-in browser translation will wreak havoc on the DOM and react will crash.
          Proceed with extreme caution! 🏗️
        */}
        <span>Remember, contributions to this repository should follow its </span>
        <span>
          {/* eslint-disable-next-line react-hooks/static-components */}
          <Links />
        </span>
        <span>.</span>
      </div>
    </Box>
  )
}

try{ ContributorFooter.displayName ||= 'ContributorFooter' } catch {}
try{ Links.displayName ||= 'Links' } catch {}